/**
 * CTA Deluxe Block - View Script
 * Handles scroll-based fade-in animations
 */

(function() {
	'use strict';

	// Check for reduced motion preference
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	if (prefersReducedMotion) {
		// If user prefers reduced motion, mark all blocks as visible immediately
		document.querySelectorAll('.block-cta-deluxe[data-animate-in]').forEach(function(block) {
			block.setAttribute('data-animate-in', 'visible');
		});
		return;
	}

	// IntersectionObserver options
	const observerOptions = {
		root: null,
		rootMargin: '0px 0px -50px 0px', // 50px bottom offset
		threshold: 0.15 // Trigger at 15% visibility
	};

	// Callback when block enters/exits viewport
	function handleIntersection(entries, observer) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting) {
				entry.target.setAttribute('data-animate-in', 'visible');
				// Stop observing once animated
				observer.unobserve(entry.target);
			}
		});
	}

	// Create observer
	const observer = new IntersectionObserver(handleIntersection, observerOptions);

	// Observe all CTA Deluxe blocks with data-animate-in attribute
	function observeBlocks() {
		document.querySelectorAll('.block-cta-deluxe[data-animate-in]').forEach(function(block) {
			observer.observe(block);
		});
	}

	// Run when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', observeBlocks);
	} else {
		observeBlocks();
	}
})();
